import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import MissionStatement from "./components/MissionStatement";
import WhoItsFor from "./components/WhoItsFor";
import StatsSection from "./components/StatsSection";
import AboutPreview from "./components/AboutPreview";
import EpisodesPreview from "./components/EpisodesPreview";
import NewsletterCTA from "./components/NewsletterCTA";
import Testimonials from "./components/Testimonials";

export default function Home() {
  return (
    <main className="min-h-screen bg-cream font-sans">
      <Navbar />
      <Hero />
      <MissionStatement />
      <WhoItsFor />
      <StatsSection />
      <AboutPreview />
      <EpisodesPreview />
      <Testimonials />
      <NewsletterCTA />
      <Footer />
    </main>
  );
}
